export const encodeStateToArray = (state: any) => {
	const encodedState = [] as any[];
	Object.keys(state).forEach((key) => {
		switch (key) {
			case 'graphViewmode':
				if (state[key] === 'trendlinjer') {
					encodedState.push(1);
				} else if (state[key] === 'råfrekvens') {
					encodedState.push(2);
				} else if (state[key] === 'galakser') {
					encodedState.push(3);
				}
				encodedState.push('_');
				break;
			case 'freq':
				if (state[key] === 'rel') {
					encodedState.push(1);
				} else if (state[key] === 'abs') {
					encodedState.push(2);
				}
				encodedState.push('_');
				break;
			case 'corpus':
				if (state[key][0] === 'bok') {
					encodedState.push(1);
				} else if (state[key][0] === 'avis') {
					encodedState.push(2);
				} else if (state[key][0] === 'all') {
					encodedState.push(3);
				}
				encodedState.push('_');
				break;
			case 'searchTerms':
				encodedState.push(state[key].join(','));
				encodedState.push('_');
				break;
			case 'lang':
				if (state[key] === 'nor') {
					encodedState.push(1);
				} else if (state[key] === 'nno') {
					encodedState.push(2);
				} else if (state[key] === 'nob') {
					encodedState.push(3);
				} else if (state[key] === 'smj') {
					encodedState.push(4);
				} else if (state[key] === 'sma') {
					encodedState.push(5);
				} else if (state[key] === 'sme') {
					encodedState.push(6);
				} else if (state[key] === 'fkv') {
					encodedState.push(7);
				}
				encodedState.push('_');
				break;
			case 'case_sens':
				if (state[key] === 0) {
					encodedState.push(1);
				} else if (state[key] === 1) {
					encodedState.push(2);
				}
				encodedState.push('_');
				break;
			case 'smoothing':
				encodedState.push(state[key]);
				encodedState.push('_');
				break;
			case 'yearSpan':
				encodedState.push(state[key].join(','));
				encodedState.push('_');
				break;
			case 'leaves':
				if (state[key]) {
					encodedState.push(1);
				} else {
					encodedState.push(2);
				}
				encodedState.push('_');
				break;
			case 'isCumulative':
				if (state[key]) {
					encodedState.push(1);
				} else {
					encodedState.push(2);
				}
				encodedState.push('_');
				break;
			case 'isGrayscale':
				if (state[key]) {
					encodedState.push(1);
				} else {
					encodedState.push(2);
				}
				encodedState.push('_');
				break;
			case 'limit':
				encodedState.push(state[key]);
				encodedState.push('_');
				break;
			case 'isEmbedded':
				if (state[key]) {
					encodedState.push(1);
				} else {
					encodedState.push(2);
				}
				break;
			default:
				break;
		}
	});

	const stringifiedState = encodedState.join('');
	const uriEncodedState = encodeURIComponent(stringifiedState);
	return uriEncodedState;
};

export function decodeStateToObject(encodedState: string) {
	const decodedState = {
		graphViewmode: 'trendlinjer',
		freq: 'rel',
		corpus: ['bok'],
		searchTerms: [],
		lang: 'nor',
		case_sens: 0,
		smoothing: 3,
		yearSpan: [1810, 2022],
		leaves: 0,
		isCumulative: false,
		isGrayscale: false,
		limit: 12,
		isEmbedded: false,
	} as any;

	const decodedStateArray = decodeURIComponent(encodedState).split('_');
	decodedStateArray.forEach((key, index) => {
		switch (index) {
			case 0:
				if (Number(key) === 1) {
					decodedState.graphViewmode = 'trendlinjer';
				} else if (Number(key) === 2) {
					decodedState.graphViewmode = 'råfrekvens';
				} else if (Number(key) === 3) {
					decodedState.graphViewmode = 'galakser';
				}
				break;
			case 1:
				if (Number(key) === 1) {
					decodedState.freq = 'rel';
				} else if (Number(key) === 2) {
					decodedState.freq = 'abs';
				}
				break;
			case 2:
				if (Number(key) === 1) {
					decodedState.corpus = ['bok'];
				} else if (Number(key) === 2) {
					decodedState.corpus = ['avis'];
				} else if (Number(key) === 3) {
					decodedState.corpus = ['all'];
				}
				break;
			case 3:
				decodedState.searchTerms = key.split(',');
				break;
			case 4:
				if (Number(key) === 1) {
					decodedState.lang = 'nor';
				} else if (Number(key) === 2) {
					decodedState.lang = 'nno';
				} else if (Number(key) === 3) {
					decodedState.lang = 'nob';
				} else if (Number(key) === 4) {
					decodedState.lang = 'smj';
				} else if (Number(key) === 5) {
					decodedState.lang = 'sma';
				} else if (Number(key) === 6) {
					decodedState.lang = 'sme';
				} else if (Number(key) === 7) {
					decodedState.lang = 'fkv';
				}
				break;
			case 5:
				if (Number(key) === 1) {
					decodedState.case_sens = 0;
				} else if (Number(key) === 2) {
					decodedState.case_sens = 1;
				}
				break;
			case 6:
				decodedState.smoothing = Number(key);
				break;
			case 7:
				const yearSpanString = key.split(',');
				decodedState.yearSpan = [
					Number(yearSpanString[0]),
					Number(yearSpanString[1]),
				];
				break;
			case 8:
				if (Number(key) === 1) {
					decodedState.leaves = 1;
				} else if (Number(key) === 2) {
					decodedState.leaves = 0;
				}
				break;
			case 9:
				if (Number(key) === 1) {
					decodedState.isCumulative = true;
				} else if (Number(key) === 2) {
					decodedState.isCumulative = false;
				}
				break;
			case 10:
				if (Number(key) === 1) {
					decodedState.isGrayscale = true;
				} else if (Number(key) === 2) {
					decodedState.isGrayscale = false;
				}
				break;
			case 11:
				decodedState.limit = Number(key);
				break;
			case 12:
				if (Number(key) === 1) {
					decodedState.isEmbedded = true;
				} else if (Number(key) === 2) {
					decodedState.isEmbedded = false;
				}
				break;
			default:
				break;
		}
	});

	return decodedState;
}
